import { CommonModule } from '@angular/common';
import type { ComponentFactory } from '@angular/core';
import { ComponentFactoryResolver, NgModule } from '@angular/core';
import { QuizWidgetComponent } from './quiz-widget/quiz-widget.component';

@NgModule({
  exports: [QuizWidgetComponent],
  imports: [CommonModule, QuizWidgetComponent],
})
export class QuizWidgetModule {
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
  public resolveComponent(): ComponentFactory<QuizWidgetComponent> {
    return this.componentFactoryResolver.resolveComponentFactory(QuizWidgetComponent);
  }
}
